// General
import React from 'react';
import { NavLink } from 'react-router-dom';
// Icons
import { TbHeartFilled } from 'react-icons/tb';

function Footer() {
  // HTML
  return (
    <React.Fragment>
      <div className='footer-container'>
        <p>&copy; TCore {new Date().getFullYear()}. All Rights Reserved. Made with  by <NavLink to="https://www.tuyak.com.tr">Tüyak</NavLink></p>
      </div>
    </React.Fragment>
  );
}

export default Footer;